export const setBit = (value: number, bit: number, set = true) => {
	return set
		? value | bit
		: value ^ (value & bit);
};
